/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";
import { useFieldSectionContext } from "../../../contexts";
import { Collapse } from "../../core";
import { isNil } from "@adapptio/lib-shared";

import "./FieldSectionContent.scss";

export interface IFieldSectionContentProps {
	children?: React.ReactNode;
	className?: string;
	disablePadding?: boolean;
	root?: boolean;
}

const FieldSectionContent: React.FC<IFieldSectionContentProps> = ({
	children,
	className,
	disablePadding,
	root
}) => {
	const fieldSectionCtx = useFieldSectionContext();
	const baseClass = BEM("edt-field-section-content", null, {
		padded: !disablePadding,
		root: isNil(root) ? fieldSectionCtx?.root : root
	});

	if (className) {
		baseClass.add(className);
	}

	return (
		<Collapse
			open={!fieldSectionCtx?.collapsible || !fieldSectionCtx?.collapsed}
			className={baseClass.toClassName()}
			unmountOnExit
		>
			<div className={baseClass.toClassName()}>{children}</div>
		</Collapse>
	);
};

const FieldSectionContentMemo = React.memo(FieldSectionContent);

export { FieldSectionContentMemo as FieldSectionContent };
